<template lang="pug">
.pen-selector(:data-vertical='isVertical')
  //- 黒ペン
  input.pen-selector__checkbox(
    type='checkbox',
    :id='getInputId(penSettings.PEN_BLACK)',
    :value='penSettings.PEN_BLACK.name',
    v-model='selectedPenName',
    @change='changePen(penSettings.PEN_BLACK)'
  )
  label-base.pen-selector__label(:for='getInputId(penSettings.PEN_BLACK)')
    image-base.pen-selector__label__icon(:src='require(`@/assets/img/pen/${iconName(penSettings.PEN_BLACK)}`)')
  //- 赤ペン
  input.pen-selector__checkbox(
    type='checkbox',
    :id='getInputId(penSettings.PEN_RED)',
    :value='penSettings.PEN_RED.name',
    v-model='selectedPenName',
    @change='changePen(penSettings.PEN_RED)'
  )
  label-base.pen-selector__label(:for='getInputId(penSettings.PEN_RED)')
    image-base.pen-selector__label__icon(:src='require(`@/assets/img/pen/${iconName(penSettings.PEN_RED)}`)')
  //- マーカー(蛍光ペン)
  input.pen-selector__checkbox(
    type='checkbox',
    :id='getInputId(penSettings.PEN_HIGHLIGHT)',
    :value='penSettings.PEN_HIGHLIGHT.name',
    v-model='selectedPenName',
    @change='changePen(penSettings.PEN_HIGHLIGHT)'
  )
  label-base.pen-selector__label(:for='getInputId(penSettings.PEN_HIGHLIGHT)')
    image-base.pen-selector__label__icon(:src='require(`@/assets/img/pen/${iconName(penSettings.PEN_HIGHLIGHT)}`)')
  //- 消しゴム
  input.pen-selector__checkbox(
    type='checkbox',
    :id='getInputId(penSettings.ERASER)',
    :value='penSettings.ERASER.name',
    v-model='selectedPenName',
    @change='changePen(penSettings.ERASER)'
  )
  label-base.pen-selector__label(:for='getInputId(penSettings.ERASER)')
    image-base.pen-selector__label__icon(:src='require(`@/assets/img/pen/${iconName(penSettings.ERASER)}`)')
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import LabelBase from '@/components/atoms/LabelBase.vue'
import ImageBase from '@/components/atoms/ImageBase.vue'
import { DrawSettings } from '@/models/drawSettings'
import { PenSettings } from '@/const/PenSettings'

/**
 * ペンの選択用コンポーネント
 */
@Component({
  components: {
    LabelBase,
    ImageBase,
  },
})
export default class PenSelector extends Vue {
  // 縦書きフラグ
  @Prop({ default: false })
  isVertical?: boolean

  // 選択中のペン
  public activePen: DrawSettings.PenAsset | null = null

  // 選択されたペンの名前を受け取る変数
  private selectedPenName: string[] = []

  // コンポーネント単位のユニークID取得
  private readonly UID = this.$uuid.v4()

  // ペン情報のアクセサ
  private get penSettings(): PenSettings {
    return PenSettings
  }

  // inputタグの個別ID
  private getInputId(pen: DrawSettings.PenAsset): string {
    return `id${this.UID}_${pen.name}`
  }

  // 選択状態に応じてアイコン画像を切り替え
  private iconName(pen: DrawSettings.PenAsset): string {
    const onOff = this.selectedPenName.includes(pen.name) ? 'on' : 'off'
    return `icon_pen_${pen.name}_${onOff}.png`
  }

  /**
   * ペンの切り替え時イベント
   */
  private changePen(pen: DrawSettings.PenAsset) {
    if (this.selectedPenName.includes(pen.name)) {
      // ペンが選択された場合、他のチェックボックスをクリアしアクティブなペンを設定する
      this.selectedPenName = [pen.name]
      this.activePen = pen
    } else {
      // 選択が解除された場合、全てのチェックボックスをクリアしペンの選択を解除する
      this.selectedPenName = []
      this.activePen = null
    }
  }

  /**
   * ペンの変更時イベント
   */
  @Watch('activePen')
  private penChanged() {
    this.$emit('updated')
  }
}
</script>

<style lang="stylus" scoped>
.pen-selector
  display flex

  &__checkbox
    display none

  &__label
    margin 0 0 0 5px
    &__icon
      width 36px
      height 32px

  &[data-vertical='true'] &__label
    margin 0 0 5px 0
</style>
